import React from "react";
import Logo from "./AkularSVGBanerLogo";
import { Auth } from "aws-amplify";
import { SignOut } from "aws-amplify-react/dist/Auth";
import {
  NavItem,
  NavBar,
  NavRight,
  Nav
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";

import AppContext from "./AppContext";

class TopPanel extends React.Component {
  constructor(props) {
    super(props);
  }

  greetings = () => {
    const { theme } = this.props;
    const { authData } = this.props;
    if (!authData) return null;
    const userAttributes = authData.attributes || this.props.userAttributes;

    if (!userAttributes) return null;

    return (
      <NavItem theme={theme} style={{ color: "black", padding: "10px 0",}}>
        {userAttributes.email}{" "}
      </NavItem>
    );
  };

  singOutButton = () => {
    const { theme } = this.props;
    const config = Auth.configure();
    const { oauth = {} } = config;
    return (
      <NavItem theme={theme} style={{ color:"black",height: "28px", padding: "0px" ,marginTop:"5px",marginBottom:"5px"}}>
        <SignOut {...this.props} auth0={oauth.auth0} />
      </NavItem>
    );
  };

  refresh = () => {
    //TODO
  };

  render() {
    const { authState } = this.props;

    const { theme } = this.props;

    return (
      <NavBar theme={theme} className="App-top-bar">
        <Nav theme={theme}>
          <NavRight theme={theme}>
            <NavItem style={{ float: "left", height: "28px", padding: "0px",marginTop:"5px",marginBottom:"5px"}}>
              <Logo />
            </NavItem>
            <NavItem style={{ verticalAlign: "middle", padding: "0px",marginTop:"5px",marginBottom:"5px" }}>
              <div style={{ height: "28px",padding: "5px 0", }}> </div>
            </NavItem>
            {this.greetings()}

            {authState === "signedIn" && this.singOutButton()}
          </NavRight>
        </Nav>
      </NavBar>
    );
  }
}
TopPanel.contextType = AppContext;

export default TopPanel;
